<div class="feedback-success">
  <div class="success-icon" aria-hidden="true"></div>

  <div class="success-content">
    <h3>Thank you for sharing your feedback with us!</h3>
    <span>Your input is invaluable.</span>
    <p>It directly helps us prioritize improvements and build experiences that make your daily routine easier.</p>
  </div>

  <div class="success-actions">
    <button type="button" class="confirm-button" (click)="onConfirm()">DONE</button>
  </div>
</div>
